<template>
    <v-dialog v-model="examineImgDialog" width="960px">
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{ $t("Examine.ExamineImg.title") }}
                </span>
                <v-spacer></v-spacer>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="examineImgDialog = false" v-bind="attrs" v-on="on">
                            fa-times
                        </v-icon>
                    </template>
                    <span>
                        {{ $t("CRUD.backToList", [$t("Examine.title")]) }}
                    </span>
                </v-tooltip>
            </v-card-title>

            <v-card-text>
                <v-row class="mt-4 table-style" no-gutters>
                    <v-col cols="12" md="4">
                        <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">
                          {{ $t("Examine.DetailFields.examine_code")}}{{ $t("Global.colon") }}
                      </span>
                            {{ item && item.examine_code ? item.examine_code : "" }}
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">
                          {{ $t("Examine.DetailFields.created_time")}}{{ $t("Global.colon") }}
                      </span>
                            {{ item && item.created ? item.created : "" | formatTime }}
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                      <span class="secondary--text">
                          {{ $t("Examine.DetailFields.examine_time")}}{{ $t("Global.colon") }}
                      </span>
                            <span> {{ item && item.examine_time ? item.examine_time : "" | formatTime }}</span>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                        <v-card class="pa-2 d-flex overflow-auto align-end" outlined tile>
                            <!-- 附件 -->
                            <span class="secondary--text text-no-wrap">
                                {{ $t("Order.Fields.attachments") }}{{ $t("Global.colon") }}
                            </span>
                            <!-- 上传附件1 -->
                            <span class="ml-4">
                                <v-card height="100" v-if="img_one" width="140">
                                    <v-img
                                      :src="img_one"
                                      @click.stop="$showFullscreenImages([img_one])"
                                      height="100"
                                      v-if="
                                  img_one.startsWith('data:image/') ||
                                  ['jpg', 'jpeg', 'gif', 'png'].includes(
                                    img_one
                                      .substring(img_one.lastIndexOf('.') + 1)
                                      .toLowerCase()
                                  )
                                "
                                      width="140"
                                    />
                                    <div max-width="140" style="position: relative" v-else>
                                        <video controls height="100" width="140">
                                            <source :src="img_one" type="video/mp4"/>
                                        </video>
                                    </div>
                                </v-card>
                            </span>
                            <!-- 上传附件2 -->
                            <span class="ml-4" v-if="showImgTwoFlg">
                                <v-card height="100" v-if="img_two" width="140">
                                    <v-img
                                        :src="img_two"
                                        @click.stop="$showFullscreenImages([img_two])"
                                        height="100"
                                        v-if="
                                          img_two.startsWith('data:image/') ||
                                          ['jpg', 'jpeg', 'gif', 'png'].includes(
                                            img_two
                                              .substring(img_two.lastIndexOf('.') + 1)
                                              .toLowerCase()
                                          )
                                        "
                                        width="140"
                                    />
                                    <div height="100" style="position: relative" v-else width="140">
                                        <video controls height="100" width="140">
                                            <source :src="img_two" type="video/mp4"/>
                                        </video>
                                    </div>
                                </v-card>
                            </span>
                            <!-- 上传附件3 -->
                            <span class="ml-4" v-if="showImgThreeFlg">
                                <v-card height="100" v-if="img_three" width="140">
                                    <v-img
                                        :src="img_three"
                                        @click.stop="$showFullscreenImages([img_three])"
                                        height="100"
                                        v-if="
                                          img_three.startsWith('data:image/') ||
                                          ['jpg', 'jpeg', 'gif', 'png'].includes(
                                            img_three
                                              .substring(img_three.lastIndexOf('.') + 1)
                                              .toLowerCase()
                                          )
                                        "
                                        width="140"
                                    />
                                    <div height="100" style="position: relative" v-else width="140">
                                        <video controls height="100" width="140">
                                            <source :src="img_three" type="video/mp4"/>
                                        </video>
                                    </div>
                                </v-card>
                            </span>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="examineImgDialog = false" color="primary" outlined>{{ $t("$vuetify.close") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>


    export default {
        name: "ExamineImgDialog",

        props: {
            value: Boolean,
            item: Object
        },
        components: {},

        data: () => ({
            examineImgDialog: false,
            examine: {},
            album: [],
            img_one: "",
            img_two: "",
            img_three: "",
            img_url_one: "",
            img_url_two: "",
            img_url_three: "",
            showImgTwoFlg: false,
            showImgThreeFlg: false,
        }),
        mounted() {

        },
        methods: {},

        watch: {
            value: {
                immediate: false, //初始赋值也调用
                handler() {
                    if (!this.value) {
                        this.examine = {};
                        this.album = [];
                        this.img_one = this.img_url_one = "";
                        this.img_two = this.img_url_two = "";
                        this.img_three = this.img_url_three = "";
                        this.showImgTwoFlg = false;
                        this.showImgThreeFlg = false;
                    }
                    this.examineImgDialog = this.value;
                },
            },
            item: {
                immediate: false, //初始赋值也调用
                handler() {
                    this.examine = this.item;
                    if (this.examine) {
                        if (this.examine.examine_file_url.image_url) {
                            this.examine.examine_file_url.image_url.forEach(
                                (img) => {
                                    this.album.push(img);
                                }
                            );
                        }
                        if (this.examine.examine_file_url.video_url) {
                            this.examine.examine_file_url.video_url.forEach(
                                (video) => {
                                    this.album.push(video);
                                }
                            );
                        }
                        this.img_file_one = null;
                        this.img_file_two = null;
                        this.img_file_three = null;
                        this.showImgTwoFlg = false;
                        this.showImgThreeFlg = false;
                        this.img_url_one = this.img_one = this.album && this.album[0] ? this.album[0] : "";
                        this.img_url_two = this.img_two = this.album && this.album[1] ? this.album[1] : "";
                        this.img_url_three = this.img_three = this.album && this.album[2] ? this.album[2] : "";
                        if (this.album && this.album[1]) {
                            this.showImgTwoFlg = true
                        }
                        if (this.album && this.album[2]) {
                            this.showImgThreeFlg = true
                        }
                    }
                },
            },
        },
    };
</script>